import { render } from "./DetailedPlatformView.vue?vue&type=template&id=7e24f3f9"
import script from "./DetailedPlatformView.vue?vue&type=script&lang=js"
export * from "./DetailedPlatformView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/wma/osd/decap/configuration-depot/configuration-depot-application/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__